import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-iconPark-voice",
  "use": "icon-iconPark-voice-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-iconPark-voice\">\r\n    <rect width=\"48\" height=\"48\" fill=\"#101010\" fill-opacity=\"0.01\" stroke=\"none\" /><rect x=\"17\" y=\"4\" width=\"14\" height=\"27\" rx=\"7\" fill=\"none\" stroke=\"#101010\" stroke-width=\"4\" stroke-linejoin=\"round\" /><path d=\"M9 23C9 31.2843 15.7157 38 24 38C32.2843 38 39 31.2843 39 23\" stroke=\"#101010\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" fill=\"none\" /><path d=\"M24 38V44\" stroke=\"#101010\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" fill=\"none\" />\r\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/iconPark-voice.svg
// module id = A2en
// module chunks = 24